import { render, staticRenderFns } from "./dialogMetadata.vue?vue&type=template&id=6b440092&scoped=true&lang=html"
import script from "./dialogMetadata.vue?vue&type=script&lang=js"
export * from "./dialogMetadata.vue?vue&type=script&lang=js"
import style0 from "./dialogMetadata.vue?vue&type=style&index=0&id=6b440092&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b440092",
  null
  
)

export default component.exports